@let checkIn = checkInFeature.selectors.checkIn.asSignal();
@let ignoreCheckInPrompt =
  checkInFeature.selectors.ignoreCheckInPrompt.asSignal();
@let response = checkInFeature.selectors.response.asSignal();

@if (checkIn && !ignoreCheckInPrompt) {
  <h3 class="atn-check-in-modal-content__title">{{ checkIn.title }}</h3>
  <p class="atn-check-in-modal-content__prompt">
    {{ checkIn.prompt }}
  </p>

  <div class="atn-check-in-modal-content__suggested-responses">
    @for (suggestedResponse of checkIn.suggestedResponses; track $index) {
      <div
        class="atn-check-in-modal-content__suggested-response"
        (click)="
          checkInFeature.actions.setResponse
            .from('CheckInModal.SuggestedResponse.Clicked')
            .dispatch(suggestedResponse)
        "
      >
        {{ suggestedResponse }}
      </div>
    }
  </div>
}

<atn-ds-text-area
  class="atn-check-in-modal-content__response"
  [styleOverrides]="{ height: '80px', resize: 'vertical' }"
  [value]="response"
  (valueChange)="
    checkInFeature.actions.setResponse
      .from('CheckInModal.ResponseInput.Changed')
      .dispatch($event)
  "
/>
